import { GdkNavigation } from "@gdk/navigation";
import { GdkDarkModeSwitch } from "@gdk/dark-mode-switch";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { ClientConfigurationContext } from "../context/ClientConfigurationContextProvider";
import { UserContext } from "../context/UserContextProvider";
import { logout } from "../api/identity";
import { applyGdsThemeFromUrl } from "../embedThemeSync";
import NavMenuList from "./Home/NavMenuList";

export default function PrimaryNavigation() {
    const user = useContext(UserContext);
    const clientConfiguration = useContext(ClientConfigurationContext);

    useEffect(() => {
        new GdkNavigation({ content: "#primary-navigation" });
        new GdkDarkModeSwitch({ content: "#dark-mode-switch" });
        applyGdsThemeFromUrl();
    }, []);

    const logoutUrl = clientConfiguration?.b2cLogoutUrl || "/";
    const onClickLogout = (event) => {
        event.preventDefault();
        logout(() => window.location.href = logoutUrl);
    };

    const getMenuItems = () => {
        let list = NavMenuList();
        return list.map(item => (
            <li key={`menu_${item.title}`}>
                <Link className='nav-menu-item' to={item.path} data-nav-items-trigger={item.children.length > 0 ? item.path : null} aria-haspopup='menu'> {item.title}</Link>
            </li>
        ));
    }

    const getSubMenus = () => {
        let list = NavMenuList();
        return list.map(item => (
            <React.Fragment key={`submenu_${item.title}`}>
                {item.children && (
                    <div className='nav-secondary-panel' data-nav-items={item.path}>
                        <a className='nav-header' style={{ cursor: 'pointer', marginBottom: 0, display: 'block', textDecoration: 'none' }} href={`/${item.path}`} role="button">{item.title}</a>
                        <ul className='nav-items'>
                            {item.children.map(child => (
                                <li key={`submenu_child_${child.title}`}>
                                    <Link className='nav-menu-item' to={child.path} state={{ ...child.state }}> {child.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </React.Fragment>
        ));
    }

    return (
        <nav id="primary-navigation" role="navigation">
            <div className="nav-background"></div>

            <div className="panel-wrapper" data-side-panel="menu">
                <div className="nav-menu">
                    <ul className="nav-primary-tier nav-items nav-dark-mode-switch-wrapper">
                        {clientConfiguration.masterSwitch && user && !user.loginRequired &&
                            <>
                                {getMenuItems()}
                            </>
                        }

                        <li className="nav-dark-mode-switch">
                            <div id="dark-mode-switch" className="button-switch-container">
                                <div className="button-switch-label-wrapper">
                                    <label htmlFor="dark-mode-switch-checkbox" className="text">Dark mode</label>
                                </div>
                                <input id="dark-mode-switch-checkbox" name="dark-mode-switch-checkbox" type="checkbox" />
                                <div className="button-switch"></div>
                            </div>
                        </li>

                        {user && !user.loginRequired &&
                            <li className="nav-additional-links menu">
                                <div className="nav-bottom-links">
                                    <ul className="list">
                                        <li className="menu">
                                            <span className="geico-icon--small icon-logout icon-padding"></span>
                                            <a href={logoutUrl} onClick={onClickLogout}>Log Out</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        }
                    </ul>
                    <div className='nav-secondary-tier'>
                        <div className='nav-back'>
                            <a href='/'>Back</a>
                        </div>
                        {getSubMenus()}
                    </div>
                </div>
            </div>
        </nav>
    );
};
